var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Critical"] = 5] = "Critical";
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    LogLevel[LogLevel["Error"] = 4] = "Error";
    LogLevel[LogLevel["Information"] = 2] = "Information";
    LogLevel[LogLevel["None"] = 6] = "None";
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    LogLevel[LogLevel["Warning"] = 3] = "Warning";
})(LogLevel || (LogLevel = {}));
export default LogLevel;
